import Vue from 'vue'
import Web from '@/website/Web.vue'
import router from '@/website/router/'
// ydUserId作为公参已经在sendLoginInfo函数中同步，私参数请不要再加了，否则会删除掉
import reportToRlog from '../utils/rlog'

import 'babel-polyfill'
if (process.env.NODE_ENV == 'development') {
  require('../mock/index')
}

Vue.config.productionTip = false
// rlog日志接口
window.reportToRlog = reportToRlog

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { Web },
  template: '<Web/>'
})
